/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


$(document).on('ready', function() {
  $(".regular").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]   	
  });

  $(".fancybox-effects-a").fancybox({
    helpers: {
      title : {
        type : 'outside'
      },
      overlay : {
        speedOut : 0
      }
    }
  });

  $(".panel_list").slick({

    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });	
  
   $(".two_panel_list").slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1
  });	
  new WOW().init();
});

$( document ).ready(function( $ ) { 
  $( document ).ready(function( $ ){ 
    
    /*setTimeout(function() {
      $.blockUI({ message: $('#question'), css: { width: '275px' },onOverlayClick: $.unblockUI  });
    }, 500);*/
    
    var cookie = getCookie('isSubscribe');
    console.log(cookie);
    
    if(cookie == null || cookie == 'undefined'){
      setTimeout(function() {
        $.blockUI({ message: $('#question'), css: { width: '275px' },onOverlayClick: $.unblockUI  });
        ///$.unblockUI('isSubscribe', true);
        setCookie('isSubscribe', true);
      }, 500);
    }
  }); 
  $('#yes').click(function() { 
    $.unblockUI();    
  });

    $('#nothanks').click(function() { 
    $.unblockUI();    
  });
  
  $(document).on('keyup',function(e) {
    if (e.which === 27) { // Escape key
      $.unblockUI();
    }
  });
}); 

$(document).ready(function(){
  $("#show_pop").click(function(){
    $.blockUI({ message: $('#question'), css: { width: '275px' },onOverlayClick: $.unblockUI  });
  });
});

function validateEmail(email){
  var re = /^(?:[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
  return re.test(email);
}

function setCustomCookie(){
  if ( $ ('#show_pop').val() != ''){ 
    if(validateEmail($('#show_pop').val())){
      setCookie('isSubscribe', true, 365);
      $.unblockUI();      	
    }
    else {
      alert (" Please Enter Valid Email Address ");
    }
  }
  else{
    alert (" Please Enter Email Address ");
  }

}
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires;
  console.log(cname + "=" + cvalue + "; " + expires);
}
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  console.log(decodedCookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
}

(function() {
    let touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      let moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});
  })();